module.exports = __webpack_public_path__ + "static/img/logo2.72783d6f.png";